<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openPostDialog">
          New Post
        </v-btn>
      </v-col>
      <v-col cols="12" v-for="post in posts" :key="post.id">
        <v-card outlined>
          <v-card-title>
            <v-avatar left>
              <v-img :src="post.userProfileImageURL || '/default-user.jpg'" />
            </v-avatar>
            {{ post.userName }}
          </v-card-title>
          <v-card-text>
            {{ post.text }}
            <v-img v-if="post.imageURL" :src="post.imageURL" class="my-2" />
            <video v-if="post.videoURL" controls :src="post.videoURL" class="my-2"></video>
          </v-card-text>
          <v-card-actions>
            <v-btn icon @click="toggleLike(post)">
              <v-icon>{{ post.likes.includes(userUID) ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
            </v-btn>
            <span>{{ post.likes.length }}</span>
            <v-btn icon @click="openComments(post)">
              <v-icon>mdi-comment-outline</v-icon>
            </v-btn>
            <span>{{ post.commentsCount }}</span>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Comments Bottom Sheet -->
    <v-bottom-sheet v-model="showCommentsSheet" inset>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on">Comments</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span>Comments for {{ selectedPost?.userName || 'Post' }}</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="comment in comments"
              :key="comment.id"
              class="comment-item"
            >
              <v-list-item-avatar>
                <v-img :src="comment.userProfileImageURL || '/default-user.jpg'" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ comment.userName }}</v-list-item-title>
                <v-list-item-subtitle>{{ comment.text }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <!-- Add Comment -->
          <v-textarea
            v-model="newCommentText"
            label="Add a comment"
            outlined
          ></v-textarea>
          <v-btn
            color="primary"
            :disabled="!newCommentText"
            @click="addComment"
          >
            Post Comment
          </v-btn>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import {
  collection,
  getDocs,
  doc,
  addDoc,
  updateDoc,
  arrayUnion,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "@/firebase";

export default {
  data() {
    return {
      posts: [],
      comments: [],
      selectedPost: null,
      newCommentText: "",
      showCommentsSheet: false,
      userUID: auth.currentUser?.uid || null,
    };
  },
  methods: {
    async fetchPosts() {
      try {
        const postsRef = collection(db, "posts");
        const postsSnapshot = await getDocs(postsRef);
        this.posts = postsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    },
    async openComments(post) {
      try {
        this.selectedPost = post;
        const commentsRef = collection(db, "comments");
        const q = query(commentsRef, where("postID", "==", post.id));
        const commentsSnapshot = await getDocs(q);
        this.comments = commentsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        this.showCommentsSheet = true;
      } catch (error) {
        console.error("Error fetching comments:", error);
      }
    },
    async addComment() {
      if (!this.newCommentText) return;
      try {
        const comment = {
          userID: this.userUID,
          userName: auth.currentUser.displayName || "Anonymous",
          userProfileImageURL: auth.currentUser.photoURL || "/default-user.jpg",
          text: this.newCommentText,
          timestamp: new Date(),
          postID: this.selectedPost.id,
        };
        const commentsRef = collection(db, "comments");
        await addDoc(commentsRef, comment);

        // Update comments count in the post
        const postRef = doc(db, "posts", this.selectedPost.id);
        await updateDoc(postRef, {
          commentsCount: this.selectedPost.commentsCount + 1,
        });

        // Update local state
        this.comments.push(comment);
        this.newCommentText = "";
        this.selectedPost.commentsCount += 1;
      } catch (error) {
        console.error("Error adding comment:", error);
      }
    },
    toggleLike(post) {
      // Handle like toggling logic here
    },
    openPostDialog() {
      this.$emit("new-post");
    },
  },
  mounted() {
    this.fetchPosts();
  },
};
</script>

<style scoped>
.comment-item {
  margin-bottom: 1rem;
}

.comment-item v-list-item-avatar {
  margin-right: 1rem;
}
</style>